<template>
	<div class="myOrderContainer">
		<div class="msg-center-nav">
			<div class="msg-categories">
				<div v-for="category in categories" :key="category.key" class="category-item"
					:class="{ 'active': activeCategory === category.key }" @click="switchCategory(category.key)">
					{{ category.name }}
				</div>
			</div>
		</div>
		<div class="orderListBox">
			<div class="orderMenu">
				<div class="menuItem">订单信息</div>
				<div class="menuItem">商品金额</div>
				<div class="menuItem">实付款</div>
				<div class="menuItem">订单操作</div>
			</div>
			<div class="checkDownload">
				<div class="check">全选</div>
				<div class="download">
					<img class="icon" src="../assets/MyOrder/iconA.png" />
					一键下载
				</div>
			</div>
			<div class="orderList" v-if="orderData.length">
				<div class="orderItem" v-for="(item,index) in orderData" :key="index">
					<div class="orderItemTop">
						<div class="timeNoDetails">
							<div class="time">{{item.create_time}}</div>
							<div class="no">订单号: {{item.order_sn}}</div>
							<div class="details" @click="naviToDetails(item)">订单详情<img class="arrow"
									src="../assets/MyOrder/iconD.png" />
							</div>
						</div>
						<div class="countdownStatus">
							<countdown :end-time="item.del_time * 1000" v-if="item.pay_status == 0 && item.status != 4">
								<template slot="process" slot-scope="{ timeObj }">
									<div class="countdown">
										<div>{{timeObj.h}}</div>:
										<div>{{timeObj.m}}</div>:
										<div>{{timeObj.s}}</div>后取消订单
									</div>
								</template>
							</countdown>
							<div class="status">{{getStatusName(item)}}</div>
						</div>
					</div>
					<div class="orderItemBottom">
						<div class="checkImgGoodsInfoBox">
							<img class="checkImg" src="../assets/MyOrder/iconE.png" />
							<div class="goodsInfoBox">
								<img class="goodsImg" :src="item.goods_img" />
								<div class="goodsInfo">
									<div class="goodsTitle ellipsis-1">{{item.goods_name}}</div>
									<div class="goodsDesc ellipsis-2">{{item.goods_content}}</div>
									<div class="tips">
										<div class="tip">{{item.cid}}</div>
										<div class="tip" v-for="(row,rowIndex) in item.yongtu" :key="rowIndex">{{row}}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="goodsPrice">
							¥{{item.original_price}}
						</div>
						<div class="costPrice">
							¥{{item.pay_price}}
							<div class="coupon">
								优惠券：-¥{{item.coupon_price}}
							</div>
						</div>
						<div class="operation">
							<div class="download" v-if="item.pay_status == 1 && item.status == 3">下载图片</div>
							<div class="apply" v-if="item.pay_status == 1 && item.status == 3 && item.invoice == 0"
								@click="applyInvoice(item)">
								<img src="../assets/MyOrder/iconB.png">
								申请发票
							</div>
							<div class="payNow" v-if="item.pay_status == 0 && item.status != 4">立即支付</div>
							<div class="cancel" v-if="item.pay_status == 0 && item.status != 4"
								@click="cancelOrder(item)">取消订单</div>
							<div class="delete" v-if="item.pay_status == 0 && item.status == 4"
								@click="deleteOrder(item)">删除</div>
						</div>
					</div>
				</div>
			</div>
			<el-empty description="暂无数据" v-else></el-empty>
		</div>
		<PagePagination style="padding: .32rem 0 0rem;" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
		<ApplyInvoiceDialog :show="dialogApplyInvoiceViable" :type="1" :orderData="curOrder"
			@close="dialogApplyInvoiceViable = false" @update="sucPop = true;normalOrder()" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'提交成功'" @clickOk="sucPop = false"
			v-if="sucPop" />
	</div>
</template>

<script>
	import PopToast from '../components/PopToast.vue'
	import ApplyInvoiceDialog from '../../src/components/ApplyInvoiceDialog.vue'
	export default {
		components: {
			ApplyInvoiceDialog,
			PopToast
		},
		data() {
			return {
				sucPop: false,
				dialogApplyInvoiceViable: false,
				// 分类导航
				categories: [{
						key: '0',
						name: '全部'
					},
					{
						key: '1',
						name: '待支付'
					},
					{
						key: '2',
						name: '已完成'
					},
					{
						key: '3',
						name: '已取消'
					}
				],
				curOrder: {},
				orderData: [],
				currentPage: 1,
				total: 0,
				activeCategory: '0',
				deadline4: Date.now() + (new Date().setHours(23, 59, 59) - Date.now()),
			}
		},
		mounted() {
			this.normalOrder()
		},
		methods: {
			onPageChange(newPage) {
				this.currentPage = newPage
				this.normalOrder()
			},
			getStatusName(item) {
				if (item.pay_status == 0) {
					if (item.status == 4) {
						return '已取消'
					} else {
						return '待支付'
					}
				} else {
					if (item.status == 3) {
						return '已完成'
					}
				}
			},
			naviToDetails(item) {
				this.$router.push({
					path: '/order-details',
					query: {
						type: 1,
						orderId: item.id
					}
				})
			},
			// 切换分类
			switchCategory(category) {
				this.activeCategory = category;
				this.normalOrder()
			},
			normalOrder() {
				this.$api.post('/Hua/hua_order_list', {
					type: this.activeCategory,
					sf_type: 1,
				}).then(res => {
					if (res.code == 1) {
						this.orderData = res.data.list
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//取消订单
			cancelOrder(item) {
				this.$confirm('确认取消当前订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Hua/hua_order_cancel', {
						id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.normalOrder()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			//删除订单
			deleteOrder(item) {
				this.$confirm('确认删除当前订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Hua/hua_order_del', {
						id: item.id,
						type: 1,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.normalOrder()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			//申请发票
			applyInvoice(item) {
				this.curOrder = item
				this.dialogApplyInvoiceViable = true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.myOrderContainer {
		display: flex;
		flex-direction: column;
		padding: .24rem .4rem;
	}

	/* 消息分类导航样式 */
	.msg-center-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid rgba(204, 204, 204, .4);
	}

	.msg-categories {
		display: flex;
		gap: .32rem;
	}

	.category-item {
		font-weight: 400;
		font-size: .16rem;
		color: #040404;
		cursor: pointer;
		padding: .24rem 0 .15rem;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: #693200;
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}

	.orderListBox {
		display: flex;
		flex-direction: column;

		.orderMenu {
			display: flex;
			align-items: center;

			.menuItem {
				height: .5rem;
				font-weight: 400;
				font-size: .14rem;
				color: #666666;
				text-align: center;
				line-height: .5rem;
			}

			.menuItem:nth-child(1) {
				width: 4rem;
			}

			.menuItem:nth-child(2) {
				width: 1.6rem;
			}

			.menuItem:nth-child(3) {
				width: 1.95rem;
			}

			.menuItem:nth-child(4) {
				width: 1.2rem;
			}
		}

		.checkDownload {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 .16rem;

			.check {
				font-weight: 400;
				font-size: .14rem;
				color: #666666;
			}

			.download {
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #A88653;

				.icon {
					margin-right: .04rem;
					width: .14rem;
					height: .14rem;
				}
			}
		}

		.orderList {
			margin-top: .1rem;
			display: flex;
			flex-direction: column;

			.orderItem {
				display: flex;
				flex-direction: column;

				.orderItemTop {
					height: .4rem;
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 0 .16rem;
					background: #FAEFDD;
					border-radius: .04rem;

					.timeNoDetails {
						display: flex;
						align-items: center;

						.time,
						.no {
							font-weight: 400;
							font-size: .14rem;
							color: #333333;
						}

						.no {
							margin-left: .16rem;
						}

						.details {
							margin-left: .16rem;
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .14rem;
							color: #A88653;
							cursor: pointer;

							.arrow {
								margin-left: .04rem;
								width: .05rem;
								height: .08rem;
							}
						}
					}

					.countdownStatus {
						display: flex;
						align-items: center;

						.countdown {
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .12rem;
							color: #252525;

							div {
								margin-left: .02rem;
								margin-right: .02rem;
								width: .22rem;
								height: .22rem;
								background: #E29358;
								border-radius: .04rem;
								line-height: .22rem;
								text-align: center;
								font-weight: 500;
								font-size: .12rem;
								color: #252525;
							}
						}

						.status {
							margin-left: .16rem;
							font-weight: 400;
							font-size: .14rem;
							color: #E29358;
						}
					}
				}

				.orderItemBottom {
					padding: .12rem 0 .24rem;
					display: flex;
					align-items: center;

					.checkImgGoodsInfoBox {
						width: 4rem;
						display: flex;
						align-items: center;

						.checkImg {
							width: .18rem;
							height: .18rem;
						}

						.goodsInfoBox {
							margin-left: .24rem;
							display: flex;
							align-items: center;

							.goodsImg {
								width: .76rem;
								height: 1.02rem;
								border-radius: .08rem;
								overflow: hidden;
								object-fit: cover;
							}

							.goodsInfo {
								width: 2.4rem;
								margin-left: .16rem;
								display: flex;
								flex-direction: column;

								.goodsTitle {
									font-weight: 700;
									font-size: .16rem;
									color: #000000;
									line-height: .22rem;
								}

								.goodsDesc {
									margin-top: .08rem;
									font-weight: 400;
									font-size: .12rem;
									color: #333333;
									line-height: .16rem;
								}

								.tips {
									margin-top: .12rem;
									display: flex;
									align-items: center;

									.tip {
										margin-right: .1rem;
										height: .26rem;
										padding: 0 .08rem;
										border-radius: .13rem;
										border: .01rem solid #A88653;
										line-height: .24rem;
										font-weight: 400;
										font-size: .12rem;
										color: #7C3E0B;
									}
								}
							}
						}
					}


				}

				.goodsPrice {
					width: 1.6rem;
					font-weight: 400;
					font-size: .14rem;
					color: #000000;
					text-align: center;
				}

				.costPrice {
					width: 1.95rem;
					display: flex;
					flex-direction: column;
					align-items: center;
					font-weight: 400;
					font-size: .14rem;
					color: #000000;

					.coupon {
						margin-top: .04rem;
						font-size: .12rem;
						color: #999999;
					}
				}

				.operation {
					width: 1.2rem;
					display: flex;
					flex-direction: column;
					align-items: center;

					.download,
					.payNow {
						width: .88rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						line-height: .36rem;
						text-align: center;
						cursor: pointer;
					}

					.apply {
						margin-top: .12rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .12rem;
						color: #333333;
						cursor: pointer;

						img {
							margin-right: .04rem;
							width: .12rem;
							height: .12rem;
						}
					}

					.cancel {
						margin-top: .12rem;
						font-weight: 400;
						font-size: .12rem;
						color: #999999;
						cursor: pointer;
					}

					.delete {
						width: .88rem;
						height: .36rem;
						border-radius: .04rem;
						border: .01rem solid #E29358;
						font-weight: 400;
						font-size: .14rem;
						color: #E29358;
						line-height: .36rem;
						text-align: center;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>